<template>
  <div
    :ref="target"
    class="video-fullscreen"
    tabindex="0"
    @keydown.esc.capture="handleClose"
  >
    <video controls autoplay playsinline @ended="onVideoEnded">
      <source :src="videoUrl" type="video/mp4" />
    </video>
    <button class="button-close" aria-role="close" @click="handleClose">
      <icon name="closeScreen" style="color: white" />
    </button>
  </div>
</template>
<script setup lang="ts">
interface Props {
  postId: string;
  videoUrl: string;
}
const props = defineProps({
  postId: null,
  videoUrl: null
});

const route = useRoute();

const target = ref();
const { focused } = useFocus(target, { initialValue: true });

const {
  categoryManager: { category },
  disciplineId,
} = inject(INJECT_CATEGORY_PAGE);

const appEvent = useAppEventPost(
  category,
  disciplineId,
  category.value.posts.find((post) => post.id === props.postId)
);

const onVideoEnded = (e) => {
  handleClose();
};

const handleClose = () => {
  navigateTo(route.path);
};

onMounted(() => {
  focused.value = true;
  appEvent.init();
});

onBeforeUnmount(() => {
  appEvent.release();
});
</script>
<style lang="scss" scoped>
.video-fullscreen {
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
}
video {
  width: 100%;
  height: 100%;
}

.button-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  background-color: black;
  .icon {
    width: 4rem;
  }
}
</style>
